"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _profile = require("@widget/profile");

var _request = require("@package/request");

var _moment = _interopRequireDefault(require("moment"));

var _reactRouterDom = require("react-router-dom");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var notifications = _interopRequireWildcard(require("@package/notifications"));

var _Loading = _interopRequireDefault(require("../components/Loading"));

var _Route = _interopRequireDefault(require("../abstracts/Route"));

var _useCheckAuth = _interopRequireDefault(require("../hooks/useCheckAuth"));

var _application = require("../context/application");

function useLoad(module) {
  var _useState = (0, _react.useState)(function () {
    return null;
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      component = _useState2[0],
      setComponent = _useState2[1];

  (0, _react.useEffect)(function () {
    module.then(function (instance) {
      return setComponent(function () {
        return instance['default'];
      });
    });
  }, [module]);
  return component;
}

function useCheckProfileData() {
  var _useContext = (0, _react.useContext)(_application.context),
      config = _useContext.config;

  var hasExcludedRoute = (0, _react.useMemo)(function () {
    return config['exclude']['routes'].some(function (route) {
      var reqExp = new RegExp(route);
      return reqExp.test(location['pathname']);
    });
  }, []);

  if (hasExcludedRoute) {
    return true;
  }

  (0, _useCheckAuth["default"])();
  return false;
}

var Loader = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var module = _ref.module,
      wrapper = _ref.wrapper;
  var Module = useLoad(module);
  var Wrapper = useLoad(wrapper);
  var navigate = (0, _reactRouterDom.useNavigate)();
  var location = (0, _reactRouterDom.useLocation)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var hasExcludedRoute = useCheckProfileData();

  var _useState3 = (0, _react.useState)(hasExcludedRoute),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isChecked = _useState4[0],
      setChecked = _useState4[1];

  (0, _react.useEffect)(function () {
    var showWarning = function showWarning() {
      dispatch(notifications.pushWarning({
        uuid: 'warning-message',
        title: 'Отключение сервиса по приему платежей банковскими картами с последующими выплатами на банковские карты',
        content: "\u0421\u0435\u0440\u0432\u0438\u0441 \u043F\u043E\xA0\u043F\u0440\u0438\u0435\u043C\u0443 \u043A\xA0\u043E\u043F\u043B\u0430\u0442\u0435 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0445 \u043A\u0430\u0440\u0442 \u0438\xA0\u0432\u044B\u043F\u043B\u0430\u0442 \u043D\u0430\xA0\u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0435 \u043A\u0430\u0440\u0442\u044B \u0432\xA0Pikassa \u0431\u0443\u0434\u0435\u0442 \u043D\u0435\xA0\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0441\xA014\xA0\u043D\u043E\u044F\u0431\u0440\u044F 2023 \u0433\u043E\u0434\u0430<br>\n                  <a href=\"".concat(process.env['PUBLIC_URL'], "/warning\">\u041A\u0430\u043A \u0432\u044B\u0432\u0435\u0441\u0442\u0438 \u043E\u0441\u0442\u0430\u0442\u043E\u043A?</a>")
      }));
    };

    var hideWarning = function hideWarning() {
      dispatch(notifications.close('warning-message'));
    };

    var excludedWarningRoutes = ['/sign-in', '/confirm', '/warning', '/offer', '/sign-up', '/set/password', '/reset/password'].some(function (route) {
      var reqExp = new RegExp(route);
      return reqExp.test(location['pathname']);
    });
    var endShow = (0, _moment["default"])('2023-11-17 00:00:00');
    var isShowWarning = (0, _moment["default"])().isBefore(endShow);

    if (isShowWarning && !excludedWarningRoutes) {
      showWarning();
    } else {
      hideWarning();
    }
  }, [location]);
  (0, _react.useEffect)(function () {
    function handleCheckAfterAuth(profile) {
      if (!profile['merchant']['type']) {
        navigate(process.env['PUBLIC_URL'] + '/confirm');
      } else if (/sign-in/.test(location['pathname'])) {
        navigate(process.env['PUBLIC_URL'] + '/');
      }

      setChecked(true);
    }

    function handleCheckAfterNotAuth() {
      setChecked(true);
    }

    _profile.events.on('auth', handleCheckAfterAuth);

    _profile.events.on('not-auth', handleCheckAfterNotAuth);

    return function () {
      _profile.events.off('auth', handleCheckAfterAuth);

      _profile.events.off('not-auth', handleCheckAfterNotAuth);
    };
  }, []);
  (0, _react.useEffect)(function () {
    function handleError(_ref2) {
      var status = _ref2.status;

      if (status === 401) {
        navigate(process.env['PUBLIC_URL'] + '/sign-in');
      }
    }

    _request.events.on('error', handleError);

    return function () {
      _request.events.off('error', handleError);
    };
  }, []);

  if (!isChecked || !Module || !Wrapper) {
    return /*#__PURE__*/_react["default"].createElement(_Loading["default"], null);
  }

  return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(Module, null));
});

var AppRoute = /*#__PURE__*/function (_AbstractRoute) {
  (0, _inherits2["default"])(AppRoute, _AbstractRoute);

  var _super = (0, _createSuper2["default"])(AppRoute);

  function AppRoute() {
    (0, _classCallCheck2["default"])(this, AppRoute);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(AppRoute, [{
    key: "render",
    value: function render() {
      return function () {
        var _this$route$wrapper, _this$route;

        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          key: this.route['path'],
          path: process.env['PUBLIC_URL'].replace(/\/$/, '') + this.route['path'],
          element: /*#__PURE__*/_react["default"].createElement(Loader, {
            module: this.route['module'],
            wrapper: this.config['wrappers'][(_this$route$wrapper = (_this$route = this.route) === null || _this$route === void 0 ? void 0 : _this$route['wrapper']) !== null && _this$route$wrapper !== void 0 ? _this$route$wrapper : 'default']
          })
        });
      }.bind(this);
    }
  }]);
  return AppRoute;
}(_Route["default"]);

var _default = AppRoute;
exports["default"] = _default;